// eslint-disable-next-line filenames/match-regex
import { BRAND_NAME } from '../../config';

export const BRAND_MESSAGE = 'ONLY THE BEST DEALS!';
export const CONTINUE = `Continue`;
export const DEALS_SUBSCRIPTION = 'Deals subscription';
export const SUBSCRIBE_CONFIRMATION = `By clicking “CONTINUE” you agree to receive daily emails featuring local service, shopping and travel offers from ${BRAND_NAME}. You can change your email preferences or unsubscribe at any time by visiting our email preference centre or by clicking on the unsubscribe option, both of which are links in each of our emails. View our Privacy & Cookie Policy  <a href="/page/privacypolicy" data-qa="privacyAndCookiesPolicy" target="_blank">HERE</a>.`;
export const EMPTY_WISHLIST_MESSAGE_ONE = 'No deals found!';
export const EMPTY_WISHLIST_MESSAGE_TWO =
  'Start adding deals to your wish list';

// EXPANDER
export const EXPANDER_MORE = 'Read more';
export const EXPANDER_LESS = 'Read less';
export const EXPANDER_MORE_MOBILE = 'More';
export const EXPANDER_LESS_MOBILE = 'Less';
export const CHARS_REMAINING = 'characters remaining...';
export const APPLY = 'Apply';
export const CLEAR = 'Clear';

// EXPANDER RELATIVE
export const SEE_LESS = 'See less';
export const SEE_MORE = 'See more';

// redeem form
export const REDEEM_CODE_BTN_CONFIRM = 'Confirm';
export const REDEEM_CODE_CONFIRM_MERCHANT =
  'I confirm that I have not redeemed this code with the merchant';
export const REDEEM_CODE_ORDER_ERROR = `Please enter a valid order number`;
export const REDEEM_CODE_ORDER_NO = 'Order Number:';
export const REDEEM_CODE_ORDER_REQUIRED = `order number is required`;
export const REDEEM_CODE_WOWCHER_CODE = (value) => `${value} Code:`;
export const REDEEM_CODE_WOWCHER_CODE_ERROR = (value) =>
  `Please enter a valid ${value} code`;
export const REDEEM_CODE_WOWCHER_CODE_REQUIRED = (value) =>
  `${value} code  is required`;
export const PREFORMATTED_STRING = {
  brandTerminology: {
    brand: '5pm',
    wowcher_or_voucher: 'voucher',
    Wowcher_or_voucher: 'voucher',
    wowchers_or_vouchers: 'vouchers',
    Wowchers_or_vouchers: 'vouchers',
  },
};
export const CREDIT_CLAIM_ERROR_CURRENCIES = (preString) =>
  `The ${preString} and deal currencies don't match.`;
export const CREDIT_CLAIM_FULL_CREDIT_REFUND =
  'Please confirm that you would like us to proceed with this request. If you have changed your mind, just press Cancel to return to the main page.';
export const CREDIT_CLAIM_NON_REFUNDABLE = (value) =>
  `Note: Part of your purchase was made with ${value} of non-refundable credit.`;
export const REDEEM_CODE_BTN_CANCEL = 'Cancel';
export const CREDIT_CLAIM_TOWARDS_DEAL = (preString, value) =>
  `Your ${preString} has been redeemed towards your purchase to the value of <strong>${value}</strong>`;
export const CREDIT_CLAIM_NOT_TOWARDS_DEAL_RETURN = (preString) =>
  `To return to the My ${preString} page, just click Done below.`;
export const REDEEM_CODE_BTN_DONE = 'DONE';
export const CREDIT_CLAIM_NOT_TOWARDS_DEAL = (preString, value) =>
  `Your ${preString} has been redeemed for <strong>${value}</strong> of credit. This is now available in your account.`;
export const CREDIT_CLAIM_REASON_ARIA_LABEL = 'Reason for refund';
export const CREDIT_CLAIM_REASON_SELECT_DEFAULT = 'Please select a reason...';
export const CREDIT_CLAIM_DEFAULT_SORRY_MESSAGE =
  'Sorry there was a problem please try again later.';

// Generic Components - components > generic
export const SELECT_MENU = {
  logout: 'Logout',
};
// SPINNER
export const PLEASE_WAIT = 'Please wait...';
// STARS
export const STAR_RATING = 'star rating';
export const LOGOUT = 'Logout';
